<template>
  <div class="corner-logo">
    <NuxtImg src="/images/banner_corner.png" alt="corner_banner" class="corner" />
    <nuxt-link href="/" class="logo">
      <NuxtImg src="/images/logo.png" alt="logo" />
    </nuxt-link>
  </div>
</template>
